<template>
  <app-list
    :status="option.status"
    :option="option"
    :remote="option.remote"
    ref="list"
    :detail="detail"
  >
    <template slot="content" slot-scope="scope">
      <div class="title">
        {{ scope.data.title }}
        <img class="img" :src="tagIcons[scope.data.roomStatus]" alt="" />
      </div>
      <div class="date">{{ formatDateTime(scope.data.liveTime) }}</div>
      <div class="datetype">{{ liveType[scope.data.type] }}</div>
    </template>

    <template slot="buttons" slot-scope="data">
      <div v-if="data.data.type != 2" class="livecbtn" @click="showShare(data)">分享</div>
      <div
        v-if="data.data.dataCount && data.data.type != 3"
        @click="getRelaList(data.data.type, data.data.id, data.data.relaDataType)"
        class="livecbtn"
      >
        查看关联
      </div>
      <template v-for="(item, index) in buttons">
        <div
          v-if="data.data.roomStatus == item.type"
          @click="item.onClick(index, data.data)"
          class="livecbtn"
          :key="index"
        >
          {{ data.data.isShow == 0 ? '测试直播' : item.value }}
        </div>
      </template>
    </template>
  </app-list>
</template>
<script>
//接口
import {
  getLivelist,
  liveStatusChange,
  liveDelete,
  zaiartOrganizationInfo,
  wxpayHas,
} from '@/api/index';

import { formatDateTime } from '@/utils/index';
//组件
import list from '@/views/components/list';
import { Toast } from 'vant';
import { Dialog } from 'vant';
export default {
  name: 'livelist',
  components: {
    appList: list,
  },
  data() {
    return {
      detail: null,
      changeEnd: false,
      binded: false,
      detail: null,
      liveType: {
        0: '拍品导购直播',
        1: '普通导购直播',
        2: '同步拍直播',
        3: '直播拍卖',
      },
      option: {
        statusKey: 'roomStatus',
        remote: {
          fetch: getLivelist,
          param: {
            name: null,
            roomStatus: null,
            page: {
              index: 1,
              size: 10,
            },
          },
        },
        status: [
          { value: '99', label: '全部' },
          { value: '0', label: '待开始' },
          { value: '1', label: '直播中' },
          { value: '2', label: '暂时离开' },
          { value: '3', label: '已结束' },
        ],
        moreButtons: [
          {
            value: '编辑',
            onClick: (index, row) => {
              this.$router.push('/live/' + row.id);
            },
          },
          {
            value: '删除',
            onClick: (index, row) => {
              Dialog.confirm({
                title: '',
                message: '确定要删除该直播吗？（确定删除将无法找回）',
              })
                .then(() => {
                  // on confirm
                  this.rm(row.id, index);
                })
                .catch(() => {
                  // on cancel
                });
            },
          },
          {
            computed: (index, row) => {
              if ((row.status == 0 && row.type == 3) || (this.status == 1 && row.type == 3)) {
                return true;
              } else {
                return false;
              }
            },
            value: '创建拍品',
            onClick: (index, row) => {
              console.log(row);
              if (row.status == 0 || row.status == 1) {
                this.$router.push({
                  path: '/auction/live/add/',
                  query: { id: row.id },
                });
              }
            },
          },
        ],
        fixButtons: [
          {
            value: '直播',
            type: 'live',
            onClick: (index, row) => {
              this.add(1);
            },
          },
          {
            value: '预告',
            onClick: (index, row) => {
              this.add(2);
            },
          },
          {
            value: '直播',
            type: 'test',
            onClick: (index, row) => {
              this.add(3);
            },
          },
        ],
      },
      buttons: [
        {
          value: '立即开播',
          type: 0,
          onClick: (index, row) => {
            if (row.type == 2) {
              let path = encodeURIComponent(`/pages/shop/select`);
              let str = encodeURIComponent('点击进入“在艺云录制端”开播');
              wx.miniProgram.navigateTo({
                url: `/pages/openMini/index?path=${path}&appid=wx0634a67e0cbf6c96&title=${str}&phone=${this.$store.state.app.userPhone}&id=${row.id}`,
              });
              return;
            }
            let path = encodeURIComponent(
              `/pages/my/liverLiveList/index?phone=${this.$store.state.app.userPhone}&id=${row.id}`,
            );
            let str = encodeURIComponent('点击进入“在艺直播”开播');
            wx.miniProgram.navigateTo({
              url: `/pages/openMini/index?path=${path}&appid=wx85f3340de9840fb8&title=${str}&phone=${this.$store.state.app.userPhone}&id=${row.id}`,
            });
          },
        },
        {
          value: '继续直播',
          type: 1,
          onClick: (index, row) => {
            if (row.type == 2) {
              let path = encodeURIComponent(`/pages/shop/select`);
              let str = encodeURIComponent('点击进入“在艺云录制端”开播');
              wx.miniProgram.navigateTo({
                url: `/pages/openMini/index?path=${path}&appid=wx0634a67e0cbf6c96&title=${str}&phone=${this.$store.state.app.userPhone}&id=${row.id}`,
              });
              return;
            }
            let path = encodeURIComponent(
              `/pages/my/liverLiveList/index?phone=${this.$store.state.app.userPhone}&id=${row.id}`,
            );
            let str = encodeURIComponent('点击进入“在艺直播”开播');
            wx.miniProgram.navigateTo({
              url: `/pages/openMini/index?path=${path}&appid=wx85f3340de9840fb8&title=${str}&phone=${this.$store.state.app.userPhone}&id=${row.id}`,
            });
            // this.changeStatus(2, row.id)
            //   .then(res => {
            //     this.changeEnd = false;
            //     Toast(res.message);
            //   })
            //   .catch(error => {
            //     this.changeEnd = false;
            //   });
          },
        },
        {
          value: '继续直播',
          type: 2,
          onClick: (index, row) => {
            if (row.type == 2) {
              let path = encodeURIComponent(`/pages/shop/select`);
              let str = encodeURIComponent('点击进入“在艺云录制端”开播');
              wx.miniProgram.navigateTo({
                url: `/pages/openMini/index?path=${path}&appid=wx0634a67e0cbf6c96&title=${str}&phone=${this.$store.state.app.userPhone}&id=${row.id}`,
              });
              return;
            }
            let path = encodeURIComponent(
              `/pages/my/liverLiveList/index?phone=${this.$store.state.app.userPhone}&id=${row.id}`,
            );
            let str = encodeURIComponent('点击进入“在艺直播”开播');
            wx.miniProgram.navigateTo({
              url: `/pages/openMini/index?path=${path}&appid=wx85f3340de9840fb8&title=${str}&phone=${this.$store.state.app.userPhone}&id=${row.id}`,
            });
            // this.changeStatus(2, row.id)
            //   .then(res => {
            //     this.changeEnd = false;
            //     Toast(res.message);
            //   })
            //   .catch(error => {
            //     this.changeEnd = false;
            //   });
          },
        },
        // {
        //   value: '结束直播',
        //   type: 1,
        //   onClick: (index, row) => {
        //     this.changeStatus(3, row.id)
        //       .then(res => {
        //         this.changeEnd = false;
        //         Toast(res.message);
        //       })
        //       .catch(error => {
        //         this.changeEnd = false;
        //       });
        //   },
        // },
      ],
      tagIcons: {
        //拍品状态iocn
        '0': 'https://img.zai-art.com/zaiart/saas/image/md/8a18959826ebeabc9a7cd15d3ac48a16.png',
        '1': 'https://img.zai-art.com/zaiart/saas/image/md/775c37e78d283ef256c52c96719d2d4d.png',
        '2': 'https://img.zai-art.com/zaiart/saas/image/md/775c37e78d283ef256c52c96719d2d4d.png',
        '3': 'https://img.zai-art.com/zaiart/saas/image/md/ac8a175fe79e2ec5c8422ed2d8c11842.png',
      },
    };
  },
  computed: {},
  created() {
    console.log(this.$store.state.app.userinfos);
    zaiartOrganizationInfo({
      shopId: this.$store.state.app.shopId,
    }).then(response => {
      this.binded = response.data.info && response.data.info.id;
    });
  },
  methods: {
    formatDateTime,
    changeStatus(status, id) {
      if (this.changeEnd) {
        return;
      }
      this.changeEnd = true;
      let param = {
        Action: 'ChangeStatus',
        id: id,
        status: status, //状态
      };
      return liveStatusChange(param);
    },
    rm(dataId, index) {
      liveDelete({ dataId }).then(res => {
        this.$refs.list.del(index, res.data.message);
      });
    },
    getRelaList(type, id, relaDataType) {
      if (type == 1) {
        // 查看普通导购直播
        this.$router.push({ path: '/rela/goodsList', query: { id: id, addType: '1' } });
      } else if (type == 0) {
        //拍品
        //根据关联类型判断，relaDataType == 0 || relaDataType == 1 查询关联限时拍拍品  ==2 同步拍拍品
        if (relaDataType == 0 || relaDataType == 1) {
          type = 1;
        } else if (relaDataType == 2) {
          type = 0;
        }
        this.$router.push({
          path: '/rela/aucArtwork',
          query: { id: id, addType: '1', aucType: type },
        });
      }
    },
    add(type) {
      if (this.binded || (this.$store.state.app.source && this.$store.state.app.source == 1)) {
        wxpayHas({ shopId: this.$store.state.app.shopId }).then(res => {
          if (res.data == 'false') {
            Dialog.confirm({
              title: '',
              message: '如需使用直播间收礼物功能，请先绑定收款账户',
              confirmButtonText: '去绑定',
              cancelButtonText: '忽略',
            })
              .then(() => {
                this.$router.push(`/capital/index`);
              })
              .catch(() => {
                this.$router.push(`/live?type=${type}`);
              });
          } else {
            this.$router.push(`/live?type=${type}`);
          }
        });
      } else {
        Dialog.confirm({
          title: '',
          message: '需要先绑定直播账号后才能创建直播',
        })
          .then(() => {
            // on confirm
            // this.$router.push(`/live?type=${type}`);
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    showShare(value) {
      this.detail = value.data;
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #222222;
  line-height: 1.5;
  height: 53px;
  text-indent: 53px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 8px;
  .img {
    position: absolute;
    width: 46px;
    height: 16px;
    line-height: 16px;
    top: 3px;
    left: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #fff;
    font-size: 10px;
    text-align: right;
    overflow: hidden;
    border-radius: 1px;
  }
}
.date {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 12px;
  position: absolute;
  bottom: 25px;
}
.datetype {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 12px;
  position: absolute;
  bottom: 0;
}
.livecbtn {
  width: 85px;
  height: 30px;
  border-radius: 4px;
  border: 1px solid #c8c8c8;
  margin-left: 10px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  &:last-child {
    border: 1px solid #222222;
    color: #222222;
  }
}
</style>
